var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-bookmarks flex items-center"},[_c('vx-tooltip',{attrs:{"text":_vm.checkModoActualForText,"position":"bottom","delay":".2s"}},[_c('feather-icon',{staticClass:"cursor-pointer p-2",attrs:{"icon":_vm.checkModoActualForIcon},on:{"click":function($event){return _vm.changeThemeMode()}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }